import { ICON__eye_slash_solid, ICON__eye_solid } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { UI_PRIMITIVE__tooltip } from '@/components/ui/UI_PRIMITIVE__tooltip';
import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import i18n_page_generation from '@/locales/keys/i18n_page_generation.json';
import { PLACEHOLDER_BUTTON__bar } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { UTILS__graph_data } from '@/utils/UTILS__graph_data';
import { FIELD__token } from '@shared/dto/generation/graph_invoke/_fields/token/FIELD__token';
import { useTranslation } from 'react-i18next';

interface Props {
  field: FIELD__token;
}

export function G_BUTTON__token_update_visibility({ field }: Props) {
  /*
   * STORE
   */

  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_GENERATION);

  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);
  const { generation_current } = use_slice_generation(['generation_current']);

  const tooltip_title = t(
    field.is_hidden.get_value()
      ? i18n_page_generation.sidebar_user_input.button.token_update_visibility.tooltip.title_show
      : i18n_page_generation.sidebar_user_input.button.token_update_visibility.tooltip.title_hide,
  );

  /*
   * EVENTS
   */
  async function onClick() {
    let field_new = field.clone();
    field_new.is_hidden.invert();

    await UTILS__graph_data.update_field(generation_current.tool.graph, field_new);
  }

  /*
   * METHODS
   */

  function is_disabled() {
    return g_general__ui_disabled;
  }

  if (field.weight.meta.grid2d__is_dimension) return <PLACEHOLDER_BUTTON__bar />;

  /*
   * HTML
   */
  return (
    <UI_PRIMITIVE__tooltip {...{ tooltip_title }}>
      <UI_PRIMITIVE__button_with_icon_animated
        variant="no-border-on-component"
        {...{ onClick }}
        disabled={is_disabled()}
        size="rect-10-6"
        iconClassNameBase="text-component-item-foreground size-3"
        iconClassNameHovered="!text-bar-foreground"
        Icon={field.is_hidden.get_value() ? ICON__eye_solid : ICON__eye_slash_solid}
      />
    </UI_PRIMITIVE__tooltip>
  );
}
